import { ImageProps } from 'next/dist/client/image';
import Image from 'next/image';
import { getPimImageAssetUrl } from 'src/services/pim';

export const PimImage = ({
  src,
  ...props
}: Omit<ImageProps, 'src'> & { src: string }) => {
  if (!src) {
    return null;
  }

  return <Image {...props} src={getPimImageAssetUrl(src)} />;
};
